<div class="wrapper">
  <div
    (mouseleave)="handleMouseleaveButton()"
    (mouseover)="handleMouseoverButton($event)"
    class="wrapper-text"
    data-cy="pdf-preview-tooltip-trigger"
  >
    <mat-icon
      *ngIf="icon"
      [ngClass]="iconEnlarge ? 'medium-icon' : 'small-icon'"
    >search</mat-icon>
    <div>{{linkText}}</div>
  </div>
</div>

<template>
  <div
    #pdf
    class="dynamic-floating-pane"
    [style.top]="top"
    [style.left]="left"
    (mouseover)="handleMouseoverMenu()"
    (mouseleave)="handleMouseleaveMenu()"
    data-cy="pdf-preview-tooltip-display"
  >
    <mojo-candidate-pdf-preview [candidateObj]="candidate">
    </mojo-candidate-pdf-preview>
  </div>
</template>
